export default "__VITE_ASSET__DKxPAykT__"